import { render, staticRenderFns } from "./WanXiangDetail.vue?vue&type=template&id=f470389c&scoped=true&"
import script from "./WanXiangDetail.vue?vue&type=script&lang=js&"
export * from "./WanXiangDetail.vue?vue&type=script&lang=js&"
import style0 from "./WanXiangDetail.vue?vue&type=style&index=0&id=f470389c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f470389c",
  null
  
)

export default component.exports